import { render, staticRenderFns } from "./suivis-kine.html?vue&type=template&id=3008b231&scoped=true&external"
import script from "./suivis-kine.js?vue&type=script&lang=js&external"
export * from "./suivis-kine.js?vue&type=script&lang=js&external"
import style0 from "./suivis-kine.scss?vue&type=style&index=0&id=3008b231&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3008b231",
  null
  
)

export default component.exports